<template>
  <div>
    <input type="radio"
           name="color"
           class="hidden_field"
           v-for="(color, idx) in colors"
           :key="idx"
           :value="color.value"
           ref="inputradio"
           v-model="selectedColor">
    <ul class="color-picker">
      <li v-for="(color, idx) in colors"
          :key="color.value"
          @click="setColor(idx)"
          class="color-picker__color hint--top"
          :aria-label="color.title"
          :class="{'isActive': isSelectedColor(color.value)}"
          :style="{'backgroundColor':color.value}">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    initialColor: {
      type: String,
      default: '#e74c3c'
    }
  },
  watch: {
    initialColor (val) {
      let idxOfColor = this.findColorIndex(this.initialColor)
      this.setColor(idxOfColor)
    },
    selectedColor (val) {
      this.$emit('changedColor', val)
    }
  },
  data () {
    return {
      selectedColor: '',
      colors: [
        {
          value: '#e74c3c',
          title: this.$t('vue2.subject.red'),
          active: false
        },
        {
          value: '#cd8c95',
          title: this.$t('vue2.subject.lightred'),
          active: false
        },
        {
          value: '#f08080',
          title: this.$t('vue2.subject.red2'),
          active: false
        },
        {
          value: '#A0A5EF',
          title: this.$t('vue2.subject.lightpurple'),
          active: false
        },
        {
          value: '#6e84c4',
          title: this.$t('vue2.subject.lightblue'),
          active: false
        },
        {
          value: '#9B63E0',
          title: this.$t('vue2.subject.purple'),
          active: false
        },
        {
          value: '#9b59b6',
          title: this.$t('vue2.subject.darkpurple'),
          active: false
        },
        {
          value: '#34495e',
          title: this.$t('vue2.subject.darkblue'),
          active: false
        },
        {
          value: '#0066cc',
          title: this.$t('vue2.subject.blue'),
          active: false
        },
        {
          value: '#578ACC',
          title: this.$t('vue2.subject.azure'),
          active: false
        },
        {
          value: '#87B0BE',
          title: this.$t('vue2.subject.lightblue2'),
          active: false
        },
        {
          value: '#85DD74',
          title: this.$t('vue2.subject.lightgreen'),
          active: false
        },
        {
          value: '#20b2aa',
          title: this.$t('vue2.subject.marinoblue'),
          active: false
        },
        {
          value: '#1abc9c',
          title: this.$t('vue2.subject.turkis'),
          active: false
        },
        {
          value: '#2baf63',
          title: this.$t('vue2.subject.green'),
          active: false
        },
        {
          value: '#93A36C',
          title: this.$t('vue2.subject.darkgreen'),
          active: false
        },
        {
          value: '#cdbe70',
          title: this.$t('vue2.subject.lightyellow'),
          active: false
        },
        {
          value: '#f1c40f',
          title: this.$t('vue2.subject.darkyellow'),
          active: false
        },
        {
          value: '#fcbb2f',
          title: this.$t('vue2.subject.lightyellow2'),
          active: false
        },
        {
          value: '#ff6600',
          title: this.$t('vue2.subject.orange'),
          active: false
        },
        {
          value: '#ff7f50',
          title: this.$t('vue2.subject.coral'),
          active: false
        },
        {
          value: '#EF8430',
          title: this.$t('vue2.subject.darkorange'),
          active: false
        },
        {
          value: '#cd661d',
          title: this.$t('vue2.subject.darkorange2'),
          active: false
        },
        {
          value: '#E1A370',
          title: this.$t('vue2.subject.bronze'),
          active: false
        },
        {
          value: '#97957F',
          title: this.$t('vue2.subject.lightbrown'),
          active: false
        },
        {
          value: '#999999',
          title: this.$t('vue2.subject.grey'),
          active: false
        },
        {
          value: '#564437',
          title: this.$t('vue2.subject.brown'),
          active: false
        }
      ]
    }
  },
  methods: {
    findColorIndex (color) {
      if (!color) {
        return -1
      }
      const normalized = color.toLowerCase()
      return this.colors.map(obj => obj.value.toLowerCase()).indexOf(normalized)
    },
    setColor (idx) {
      this.selectedColor = this.colors[idx].value
      if (this.$refs.inputradio[idx]) {
        this.$refs.inputradio[idx].focus()
      }
      let el = document.querySelector('#subject_color')
      if (el) {
        el.value = this.colors[idx].value
      }
    },
    isSelectedColor (val) {
      return this.selectedColor === val
    }
  },
  mounted () {
    let el = document.querySelector('#subject_color')
    if (el) {
      this.initialColor = el.value
    }
    let idxOfColor = this.findColorIndex(this.initialColor)
    this.setColor(idxOfColor)
  }
}
</script>

<style scoped>

.color-picker {
  height: 40px;
  max-width: 810px;
  display: flex;
}

.color-picker__color {
  flex: 1;
  height: 24px;
  cursor: pointer;
  transition: all 0.2s;
}

.color-picker__color:hover,
.color-picker__color.isActive {
  height: 34px;
  margin-top: -5px
}

.hidden_field {
  height: 0;
  width: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
}

.color-picker .color-picker__color:first-child {
  border-radius: 4px 0 0 4px;
}

.color-picker .color-picker__color:last-child {
  border-radius: 0 4px 4px 0;
}

</style>



// WEBPACK FOOTER //
// ColorPicker.vue?35bf9144